import React from 'react';
import { useSearchResults, useSearchQuestion } from '@context/DataContext';
import SearchTabSaved from '@atoms/SearchTabSaved/SearchTabSaved';
const SearchTabs = () => {
  const { resultTab, contentHeadings, tabNames } = useSearchResults();
  const { setTab } = useSearchQuestion();
  const active = resultTab === tabNames.all ? 'base-search-tabs-control__link--active' : '';
  return (
    <div className="base-search-tabs mt-auto mb-auto">
      <ul className="base-search-tabs__control-list" role="tablist">
        <li className="base-search-tabs-control__item" role="presentation">
          <button 
            className={`base-search-tabs-control__link ${active}`} 
            onClick={() => setTab(tabNames.all)} 
            role="tab"
            aria-selected={resultTab === tabNames.all}
          >
            {contentHeadings?.tabAll || 'Search Results'}
          </button>
        </li>
        <SearchTabSaved />
      </ul>
      <div className="base-search-tabs__control-separator"></div>
    </div>
  );
};
export default SearchTabs;
